import { Editor, Transforms, Path, Range, Element, BasePoint } from 'slate';
import { ReactEditor } from 'slate-react';
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';

const getLeftChar = (editor: ReactEditor, point: BasePoint) => {
  const end = Range.end(editor.selection as Range);

  return Editor.string(editor, {
    anchor: {
      path: end.path,
      offset: point.offset - 1,
    },
    focus: {
      path: end.path,
      offset: point.offset,
    },
  });
};

const getRightChar = (editor: ReactEditor, point: BasePoint) => {
  const end = Range.end(editor.selection as Range);

  return Editor.string(editor, {
    anchor: {
      path: end.path,
      offset: point.offset,
    },
    focus: {
      path: end.path,
      offset: point.offset + 1,
    },
  });
};

const wordRegexp = /[0-9a-zA-Z-]/;

const getCurrentSelection = (editor: ReactEditor) => {
  const { selection } = editor;

  if (selection) {
    const end = Range.end(selection);
    let currentWord = '';
    const currentPosition = _cloneDeep(end);
    let startOffset = end.offset;
    let endOffset = end.offset;

    // (note - pearl) Go left from the cursor until finding a non-word character
    while (currentPosition.offset >= 0 && getLeftChar(editor, currentPosition).match(wordRegexp)) {
      currentWord = getLeftChar(editor, currentPosition) + currentWord;
      startOffset = currentPosition.offset - 1;
      currentPosition.offset--;
    }

    // (note - pearl) Go right from the cursor until finding a non-word character
    currentPosition.offset = end.offset;
    while (currentWord.length && getRightChar(editor, currentPosition).match(wordRegexp)) {
      currentWord += getRightChar(editor, currentPosition);
      endOffset = currentPosition.offset + 1;
      currentPosition.offset++;
    }

    const currentRange: Range = {
      anchor: {
        path: end.path,
        offset: startOffset,
      },
      focus: {
        path: end.path,
        offset: endOffset,
      },
    };

    return {
      currentWord,
      currentRange,
    };
  }

  return {};
};

export default getCurrentSelection;
